import { map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ExceptionService } from '@base/exceptions.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApplicationHttpClient } from '@base/http-client';
import { Injectable } from '@angular/core';
import { moduleRoutes } from './urlmap';
import { IErrorResponse, ITableauLink, } from '@interfaces';

@Injectable()
export class TableauLinkService {
  private mapRoutes = moduleRoutes;

  private linksState: ITableauLink[] = [];
  private bsLinksState = new BehaviorSubject<ITableauLink[]>(this.linksState);

  constructor(
    private http: ApplicationHttpClient,
    private exceptionService: ExceptionService,
  ) {
    //
  }

  getLinks() {
    return this.http.Get(this.mapRoutes.getLinks).pipe(
      map((res: ITableauLink[]) => {
        this.linksState = res;
        this.bsLinksState.next(this.linksState);
        return res;
      },
      (err: HttpErrorResponse) => {
        const error: IErrorResponse = this.exceptionService.errorHandling(err);
      })
    );
  }

  setLinks(links: ITableauLink[]) {
    this.linksState = links;
    this.bsLinksState.next(this.linksState);
  }

  observeLinks(): Observable<ITableauLink[]> {
    return this.bsLinksState.asObservable();
  }
}
